<div class="form-group m">
    <input
        class="form-control"
        autocomplete="off"
        [type]="type"
        [name]="name"
        [id]="id"
        [placeholder]="placeholder"
        [(ngModel)]="value">
    <!--    <div class="form-text text-danger">-->
    <!--        <span>Email can't be blank</span>-->
    <!--    </div>-->
</div>
